<!-- prettier-ignore -->

<div class="chat__recommended">
  
  @if(dataChat.recommendedMessagesCurrentLang().length > 0 && !dataChat.hasHistory()){
    @for( message of dataChat.recommendedMessagesCurrentLang(); track $index ){
      <button class="chat__recommended-button" (click)="handleClick(message)">{{message}}</button>
    }
  }
  
</div>
